import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigurationService } from 'src/app/core/services/app-configuration.service';
import { EnrollmentPaymentRedsys } from '../models/enrollment-payment-redsys.model';

@Injectable({
    providedIn: 'root',
})
export class EnrollmentPaymentRedsysService {

    private readonly apiURL    : string;
    private readonly paymentURL: string;

    constructor (private readonly http: HttpClient, private readonly appConfigurationService: AppConfigurationService) {

        this.apiURL     = this.appConfigurationService.baseApi + '/enrollmentpayment';
        this.paymentURL = this.appConfigurationService.paymentApi;

    }

    public getRequest(enrollmentCode: string) {

        const url = `${this.apiURL}/redsys/request/${enrollmentCode}`;
        return this.http.get<EnrollmentPaymentRedsys>(url);

    }

    public sendRequest(request: EnrollmentPaymentRedsys) {

        const form_tpv = document.createElement('form');
              form_tpv.setAttribute('method', 'post');
              form_tpv.setAttribute('action', this.paymentURL);

        const inputMerchantParameters = document.createElement('input');
            inputMerchantParameters.setAttribute('type', 'hidden');
            inputMerchantParameters.setAttribute('name', 'Ds_MerchantParameters');
            inputMerchantParameters.setAttribute('value', request.ds_MerchantParameters);

        const inputSignature = document.createElement('input');
              inputSignature.setAttribute('type', 'hidden');
              inputSignature.setAttribute('name', 'Ds_Signature');
              inputSignature.setAttribute('value', request.ds_Signature);

        const inputSignatureVersion = document.createElement('input');
              inputSignatureVersion.setAttribute('type', 'hidden');
              inputSignatureVersion.setAttribute('name', 'Ds_SignatureVersion');
              inputSignatureVersion.setAttribute('value', request.ds_SignatureVersion);

        form_tpv.appendChild(inputMerchantParameters);
        form_tpv.appendChild(inputSignature);
        form_tpv.appendChild(inputSignatureVersion);

        document.body.appendChild(form_tpv);
        form_tpv.submit();

    }

}
